import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {Store} from '@ngrx/store';
import {AppConfigService} from './services/app-config.service';
import * as fromStore from './store';
import {map, take} from 'rxjs/operators';
import {urlPath} from './shareModel';

@Injectable({
  providedIn: 'root'
})
export class AuthAdminGuard implements  CanActivate {
  isAdmin: boolean;
  constructor(
    private store: Store<fromStore.State>,
    private router: Router,
    private appConfigService:　AppConfigService
  ) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    return this.packageSettingActivate(url);
  }
  canLoad(route: Route, state: RouterStateSnapshot): Observable<boolean> {
    const url: string = state.url;
    return this.packageSettingActivate(url);
  }

  packageSettingActivate(url) {
    // const config = this.appConfigService.getConfig();
    return this.store.select(fromStore.getCurrentUser).pipe(
      map(user => {
        // this.isAdmin =  config['adminList'].some(i => i.toLowerCase() === user.currentUser.toLowerCase());
        // if (!this.isAdmin) {
        //   this.router.navigate(['/index']);
        // }
        if (user.authority && user.authority > 0) {
          if (url.startsWith('/' + urlPath['Package']) || url.startsWith('/' + urlPath['PlanManagement'])) {
            return user.authority === 2;
          } else if (url.startsWith('/' + urlPath['PrivacyAndTerms'])) {
            return user.authority === 2;
          }
          return true;
        }
        return false;
        // return this.isAdmin;
      }),
      take(1)
    );
  }
}
